import { mapState } from 'vuex';

export default  {	
	data () {
		return { 
			active: 1

		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'admin_usuarios'}) 
	},
	methods: {
			
		
		
	}
}
